var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-0 map-container",attrs:{"flat":"","tile":"","data-testid":_vm.getTestId('site-map')}},[_c('div',{attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }